import { useTranslation } from "react-i18next"
import { Typography } from "@mui/material"
import { alpha } from "@mui/material/styles"

import {
  PLOT_CARD_PADDING_BOTTOM,
  PLOT_CARD_PADDING_X,
  SECTIONS_BORDER_RADIUS,
} from "helpers/utils/constants"
import CustomLink from "widgets/common/CustomLink"

const OPEN_METEO_URL = "https://open-meteo.com/"
const LICENCE_URL = "https://creativecommons.org/licenses/by/4.0/"
const LICENCE_NAME = "CC BY 4.0"

const captionStyles = {
  fontSize: 10,
  lineHeight: 1.4,
  fontWeight: 500,
  color: "neutral.600",
}

const BORDER_OPACITY = 0.6

const linkStyles = {
  ...captionStyles,
  cursor: "pointer",
  "&:hover": { textDecoration: "underline" },
}

const WeatherServiceAttribution = () => {
  const { t } = useTranslation()

  return (
    <Typography
      sx={{
        ...captionStyles,
        alignSelf: { xs: "stretch", sm: "flex-end" },
        maxWidth: { xs: "none", sm: "100%" },
        textAlign: { xs: "center", sm: "right" },
        mt: 0.5,
        ml: { xs: `-${PLOT_CARD_PADDING_X.xs}`, sm: 0 },
        mr: {
          xs: `-${PLOT_CARD_PADDING_X.xs}`,
          sm: `-${PLOT_CARD_PADDING_X.sm}`,
        },
        mb: `-${PLOT_CARD_PADDING_BOTTOM}`,
        borderStyle: "solid",
        borderWidth: { xs: "1px 0 0", sm: "1px 0 0 1px" },
        borderColor: (theme) => alpha(theme.palette.neutral[400], BORDER_OPACITY),
        borderTopLeftRadius: { xs: 0, sm: SECTIONS_BORDER_RADIUS },
        px: 0.75,
        py: 0.5,
      }}
      data-testid="weather-service-attribution"
    >
      <CustomLink
        href={OPEN_METEO_URL}
        component="span"
        target="_blank"
        styles={linkStyles}
      >
        {t("plot_legends.WEATHER_SERVICE_ATTRIBUTION")}
      </CustomLink>
      {" \u00b7 "}
      <CustomLink href={LICENCE_URL} component="span" target="_blank" styles={linkStyles}>
        {LICENCE_NAME}
      </CustomLink>
    </Typography>
  )
}

export default WeatherServiceAttribution
